import React, { Component } from 'react';
import { GenericEditPanel, GenericSelect, GenericOption } from 'com-gyf-webcore-userinterfacecomponents';

class ModalidadDistribucionLimiteTarjeta extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        let modalidades = JSON.parse(JSON.stringify(this.props.data.accountData.GET_MODALIDAD_DISTRIBUCION_LIMITE));
        let modalidadId = this.props.data.ModalidadDistribucionLimiteId;
        let modalidadDistribucionLimite = modalidades.find(x => x.ModalidadDistribucionLimiteId == modalidadId);

        return (
            <div className="row bottom-separator-xs">
                <div className="col-xs-12">
                    <div className="row">
                        <div className="col-xs-12">
                            <label className="label-primary">Modelo de asignación de límites a tarjetas</label>
                        </div>
                    </div>
                    <label className="label-secondary" >{modalidadDistribucionLimite ? modalidadDistribucionLimite.Descripcion : ""}</label>
                </div>
            </div>
        );
    }
}

export default ModalidadDistribucionLimiteTarjeta;